export default __webpack_public_path__ + "static/media/tr_4.13b6a6fd.mp3";